export const PAGE_TITLE = "Welcome to IIH Ambassador Program";

export const PAGE_TEXT =
  "Offered by the Institute of Interpersonal Hypnotherapy The IIH Ambassador Program is designed for graduates who wish to grow alongside us while earning commission-based rewards for referring new students. It's our way of saying thank you for helping us expand our community and mission.";

export const INTRO_TEXT = "As an IIH Ambassador, you'll receive:";

export const CTA_TEXT =
  "Kindly complete this form to apply as an ambassador, and keep an eye on your email for the next steps from our team.";

export const FORM_SECTION_TITLE = "Become an Ambassador";

export const FORM_EMBED_SCRIPT_URL =
  "https://link.msgsndr.com/js/form_embed.js";

export const FORM_EMBED = {
  src: "https://api.leadconnectorhq.com/widget/form/svJyiqwV71yEUywhsEUS",
  formId: "svJyiqwV71yEUywhsEUS",
  title: "Become an Ambassador",
  height: "720px",
  dataLayout: '{"id":"INLINE"}',
};

export const AMBASSADOR_DATA = [
  {
    id: 2,
    text: "<b>$500 referral fee</b> <i>(paid once your referral completes their training)</i>",
    value: "referral_fee",
  },
  {
    id: 3,
    text: "<b>Personal affiliate code</b> to track your referrals",
    value: "affiliate_code",
  },
  {
    id: 4,
    text: "<b>A featured interview</b> on the Illuminated Mind Podcast",
    value: "podcast_interview",
  },
  {
    id: 5,
    text: "<b>Priority placement</b> in the IAIH Member Directory",
    value: "priority_directory",
  },
  {
    id: 6,
    text: "<b>Your listing</b> on the IIH website's Staff page",
    value: "website_listing",
  },
];
